import { jsxs as r, jsx as C } from "react/jsx-runtime";
function t(l) {
  return /* @__PURE__ */ r("svg", { fill: "none", height: "21", viewBox: "0 0 21 21", width: "21", xmlns: "http://www.w3.org/2000/svg", ...l, children: [
    /* @__PURE__ */ C(
      "path",
      {
        d: "M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21Z",
        fill: "#03325B"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M12.4626 8.67272L11.0425 8.66885C11.0173 8.66934 10.9923 8.66433 10.9692 8.65418C10.9461 8.64402 10.9254 8.62895 10.9087 8.61003C10.8901 8.59141 10.8755 8.5692 10.8658 8.54475C10.856 8.52031 10.8514 8.49413 10.8521 8.46783L10.8549 7.42481C10.8544 7.3986 10.8592 7.37256 10.8691 7.34827C10.8789 7.32397 10.8936 7.30193 10.9122 7.28347C10.9291 7.26474 10.9498 7.24985 10.973 7.23982C10.9962 7.22978 11.0212 7.22483 11.0464 7.22529L12.4667 7.22917C12.5006 7.22608 12.5344 7.23602 12.5612 7.25695C12.588 7.27788 12.6058 7.30824 12.6111 7.34186L13.0939 6.98334C13.0339 6.87176 12.9396 6.78251 12.8248 6.72889C12.7143 6.67135 12.5917 6.64113 12.4671 6.64076L11.0475 6.63689C10.6241 6.63689 10.2811 6.98894 10.2803 7.4233L10.2783 8.46632C10.2768 8.90046 10.6179 9.25402 11.0413 9.25682L12.4609 9.2607C12.5892 9.25607 12.714 9.21765 12.8226 9.14931C12.9355 9.08511 13.0373 9.00328 13.1243 8.90692L12.7 8.50962C12.6111 8.61821 12.5346 8.67272 12.4626 8.67272Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        clipRule: "evenodd",
        d: "M8.59643 6.63022L10.0318 6.63409C10.248 6.63413 10.4558 6.71774 10.6118 6.86743C10.6871 6.93993 10.747 7.02696 10.7877 7.12324C10.8284 7.21953 10.8492 7.32307 10.8488 7.42761L10.846 8.46891C10.8455 8.57325 10.8238 8.67639 10.7823 8.77212C10.7408 8.86784 10.6803 8.95416 10.6045 9.02586C10.4479 9.17389 10.2402 9.25578 10.0247 9.25446L8.58932 9.25058C8.3732 9.25072 8.16541 9.16718 8.00953 9.01746C7.93409 8.94534 7.87407 8.85866 7.83311 8.76267C7.79215 8.66668 7.7711 8.56337 7.77124 8.459L7.77404 7.41749C7.77431 7.313 7.79578 7.20965 7.83715 7.1137C7.87851 7.01774 7.93892 6.93118 8.01471 6.85924C8.17171 6.71056 8.38021 6.62847 8.59643 6.63022ZM10.1693 8.60788C10.1889 8.59001 10.2045 8.56816 10.2151 8.54379C10.2256 8.51942 10.2309 8.49309 10.2304 8.46654L10.2335 7.42503C10.234 7.39832 10.229 7.37178 10.219 7.34704C10.2089 7.3223 10.1939 7.29987 10.1748 7.28112C10.1558 7.26237 10.1332 7.2477 10.1083 7.23799C10.0834 7.22828 10.0568 7.22374 10.0301 7.22466L8.59471 7.22078C8.56816 7.22005 8.54174 7.22483 8.51712 7.2348C8.4925 7.24477 8.47021 7.25973 8.45165 7.27874C8.43199 7.29659 8.41636 7.31843 8.40581 7.3428C8.39526 7.36718 8.39003 7.39352 8.39046 7.42007L8.38766 8.46137C8.38714 8.48792 8.39224 8.51428 8.40264 8.53871C8.41304 8.56315 8.42849 8.58511 8.44799 8.60314C8.46649 8.62221 8.48873 8.63727 8.5133 8.64739C8.53787 8.65751 8.56426 8.66247 8.59083 8.66196L10.0256 8.66584C10.0522 8.66684 10.0788 8.66222 10.1036 8.65227C10.1283 8.64232 10.1507 8.62727 10.1693 8.60809V8.60788Z",
        fill: "white",
        fillRule: "evenodd"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M3.84177 10.0383C4.41445 10.0383 4.72514 10.3498 4.72514 10.9275V11.2086C4.72514 11.7863 4.41381 12.0978 3.84177 12.0978H3.60477V13.5545H3.07324V10.0383H3.84177ZM3.60477 11.6055H3.82023C4.0764 11.6055 4.19189 11.47 4.19189 11.1746V10.9636C4.19189 10.6672 4.0764 10.5327 3.82023 10.5327H3.60477V11.6055Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M5.89612 12.0676H5.65007V13.5543H5.11768V10.0383H5.8862C6.45867 10.0383 6.76957 10.3498 6.76957 10.9275V11.1785C6.76957 11.5503 6.63901 11.8115 6.39274 11.9522L6.8801 13.5545H6.31819L5.89612 12.0676ZM5.65007 11.5753H5.86552C6.1217 11.5753 6.2374 11.4398 6.2374 11.1433V10.9626C6.2374 10.6661 6.1217 10.5317 5.86552 10.5317H5.65007V11.5753Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M7.84977 10.5306V11.5251H8.62843V12.0174H7.84977V13.0622H8.81415V13.5545H7.31738V10.0383H8.81415V10.5306H7.84977Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M11.0396 13.5545V11.1132H11.0295L10.5876 13.0523H10.2711L9.829 11.1132H9.81909V13.5545H9.31665V10.0383H10.0149L10.4318 11.9261H10.442L10.8537 10.0374H11.572V13.5537L11.0396 13.5545Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C("path", { d: "M12.1956 13.5545V10.0383H12.7287V13.5545H12.1956Z", fill: "currentColor" }),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M14.9674 12.7664C14.9674 13.3188 14.6509 13.6051 14.1386 13.6051C13.6361 13.6051 13.3198 13.3188 13.3198 12.7664V10.0383H13.833V12.7509C13.833 13.007 13.9485 13.1025 14.1347 13.1025C14.3208 13.1025 14.4363 13.007 14.4363 12.7509V10.0383H14.9689L14.9674 12.7664Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M17.2833 13.5545V11.1132H17.2732L16.8313 13.0523H16.5148L16.0727 11.1132H16.0627V13.5545H15.5603V10.0383H16.2586L16.6755 11.9261H16.6856L17.0974 10.0374H17.8157V13.5537L17.2833 13.5545Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M10.48 20.5323C8.00641 20.5292 5.62213 19.6074 3.78969 17.9459C1.95724 16.2843 0.807248 14.0013 0.562788 11.5398C0.318328 9.07835 0.996827 6.61381 2.46667 4.62427C3.93651 2.63474 6.09292 1.26205 8.51758 0.772477C10.9422 0.282904 13.4623 0.711351 15.589 1.97471C17.7156 3.23806 19.2972 5.24626 20.027 7.60976C20.7568 9.97325 20.5827 12.5236 19.5385 14.766C18.4943 17.0084 16.6545 18.783 14.3759 19.7456C13.1434 20.2672 11.8183 20.5347 10.48 20.5323ZM10.48 0.945443C8.11316 0.948386 5.83177 1.83032 4.07839 3.42017C2.32501 5.01002 1.22463 7.19445 0.990716 9.54971C0.756798 11.905 1.40601 14.2632 2.81243 16.1668C4.21884 18.0705 6.28219 19.3839 8.60222 19.8524C10.9222 20.3208 13.3336 19.9108 15.3684 18.702C17.4033 17.4931 18.9166 15.5716 19.6148 13.3101C20.3131 11.0485 20.1465 8.60831 19.1473 6.4627C18.1481 4.31709 16.3877 2.61907 14.2074 1.69803C13.0282 1.19899 11.7604 0.94302 10.48 0.945443Z",
        fill: "currentColor"
      }
    )
  ] });
}
export {
  t as default
};
